import { render, staticRenderFns } from "./DailyTasksKiko.vue?vue&type=template&id=21c03b6c&scoped=true"
import script from "./DailyTasksKiko.vue?vue&type=script&lang=js"
export * from "./DailyTasksKiko.vue?vue&type=script&lang=js"
import style0 from "./DailyTasksKiko.vue?vue&type=style&index=0&id=21c03b6c&prod&lang=less&scoped=true"
import style1 from "./DailyTasksKiko.vue?vue&type=style&index=1&id=21c03b6c&prod&lang=less&scoped=true"
import style2 from "./DailyTasksKiko.vue?vue&type=style&index=2&id=21c03b6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c03b6c",
  null
  
)

export default component.exports